import React from 'react';

const bullets = {
  en: [
    'Styling for figure and occasion',
    'Beauty for camera and daylight',
    'Pose and expression for castings',
    'Clear steps, in your own pace',
  ],
  de: [
    'Styling nach Figur und Anlass',
    'Beauty für Kamera und Tageslicht',
    'Pose und Ausdruck für Castings',
    'Klare Schritte, in deinem Tempo',
  ],
};

export default function FinalCTA({ lang }) {
  const t = {
    supra: lang === 'de' ? 'Atelier' : 'Atelier',
    headline:
      lang === 'de' ? 'DEIN NÄCHSTER LOOK ENTSTEHT HIER' : 'YOUR NEXT LOOK STARTS HERE',
    sub:
      lang === 'de'
        ? 'Öffne ModelCamp und arbeite an Mode, Beauty und Modelpräsenz, Schritt für Schritt.'
        : 'Open ModelCamp and work on fashion, beauty and model presence, step by step.',
    cta: lang === 'de' ? 'ZUM ATELIER' : 'TO THE ATELIER',
    trust:
      lang === 'de'
        ? 'Anmeldung mit Mobilnummer · Konditionen in den AGB'
        : 'Sign-up with your mobile number · Terms in the AGB',
  };

  return (
    <section className="bg-stone-950 py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-rose-900/20 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-rose-200/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-white/10 text-rose-100 text-xs font-bold uppercase tracking-widest rounded-full mb-6">
          {t.supra}
        </span>

        <h2 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black text-white tracking-tight mb-6">
          {t.headline}
        </h2>

        <p className="text-white/75 text-lg max-w-xl mx-auto leading-relaxed mb-10">{t.sub}</p>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {bullets[lang].map((b, i) => (
            <span
              key={i}
              className="px-4 py-2 bg-white/10 text-white text-sm font-semibold rounded-full border border-white/20 backdrop-blur-sm"
            >
              {b}
            </span>
          ))}
        </div>

        <a
          href="/s"
          className="inline-flex items-center gap-3 px-10 py-5 bg-white text-stone-950 font-black text-xl rounded-2xl shadow-2xl hover:bg-rose-50 hover:scale-105 transition-all duration-300"
        >
          {t.cta}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </a>

        <p className="mt-8 text-white/50 text-sm">{t.trust}</p>
      </div>
    </section>
  );
}
